<mat-spinner *ngIf="isLoading" class="loading-spinner"></mat-spinner>


<div class="container-profile" *ngIf="!isLoading">

    <app-alert-message></app-alert-message>
    
    <div class="container-top">
        <header>
            <h1>{{ 'profile.company-profile' | translate}}</h1>
            <p>{{ 'profile.information' | translate}}</p>
        </header>

        <div class="pulsanti">
            <button class="cancelButton" (click)="toggleCancel()" *ngIf="editing == true"><mat-icon>close</mat-icon>{{ 'profile.cancel' | translate }}</button>
            <button class="saveButton" (click)="saveCompany()" *ngIf="editing"><mat-icon>save</mat-icon>{{ 'profile.save' | translate }}</button>
            <button class="saveButton" (click)="toggleEdit()" *ngIf="editing == false"><mat-icon>edit</mat-icon>{{'profile.edit-profile' | translate}}</button>
        </div>
    </div>

    <div class="container-bottom">
        <div class="left">
            <div class="title">
                <h1>{{ 'profile.company-logo' | translate }}</h1>
            </div>

            <div class="logo">
            <ng-container *ngIf="logoPreview">
                <img [src]="logoPreview" alt="Preview" style="max-width: 80%; margin-top: 0.5rem;">
            </ng-container>

            <ng-container *ngIf="editing">
                <label for="logoInput" class="upload-label">
                {{ 'profile.upload-logo' | translate }}
                </label>
                <input 
                type="file" 
                id="logoInput" 
                #logoInput
                (change)="onLogoSelected($event)" 
                accept="image/*"
                hidden >

                <div class="logoOptions">

                <button mat-raised-button color="primary" (click)="logoInput.click()">
                <mat-icon>upload</mat-icon>{{ 'profile.upload-file' | translate }}
                </button>
                
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>

                <button mat-raised-button color="primary" (click)="deleteLogo()" [disabled]="!logoPreview"> <mat-icon>delete_forever</mat-icon>{{ 'profile.delete' | translate }}</button>

                </div>

            </ng-container>

            <ng-container *ngIf="!editing && !logoPreview">
                <p>{{ 'profile.no-logo-upload' | translate }}</p>
            </ng-container>
            </div>

            <div class="description-company content-information" *ngIf="companyData">
                <div class="content-information">
                    <div class="description-header">
                        <label>{{ 'profile.description' | translate}}</label>
                        <span class="char-counter" *ngIf="editing" [class.error]="getDescriptionLength() > 150">
                            {{ getDescriptionLength() }}/150
                        </span>
                    </div>

                    <!-- Mostra descrizione giustificata se non in editing -->
                    <p *ngIf="!editing" class="justified-text">
                    {{ companyData.description }}
                    </p>

                    <!-- Mostra textarea se in editing -->
                    <textarea *ngIf="editing" 
                        rows="5" 
                        name="description" 
                        [(ngModel)]="companyData.description"  
                        (input)="onDescriptionInput($event)"
                        maxlength="150"
                        placeholder="{{ 'profile.description-placeholder' | translate }}" 
                        [disabled]="!editing" 
                        [class.editing]="editing"
                        [class.char-warning]="getDescriptionLength() > 120"
                        [class.char-error]="getDescriptionLength() > 150">
                    </textarea>
                    <div *ngIf="editing && getDescriptionLength() > 150" class="char-error-message">
                        {{ 'profile.description-max-length' | translate }}
                    </div>

                </div>
            </div>
        </div>

        <div class="right">
            <div class="title">
                <h1>{{ 'profile.company-information' | translate }}</h1>
            </div>

            <div class="content"  *ngIf="companyData">
                <div class="content-information">
                    <label>{{ 'profile.name' | translate}}</label>
                    <input type="text" [(ngModel)]="companyData.name" placeholder="{{ 'profile.name-placeholder' | translate }}" required [disabled]="!editing" [class.editing]="editing">
                </div>

                <div class="content-information">
                    <label>	<mat-icon>link</mat-icon>{{ 'profile.website' | translate}}</label>
                    <input type="text" [(ngModel)]="companyData.webSite"  placeholder="{{ 'profile.website-placeholder' | translate }}" [disabled]="!editing" [class.editing]="editing">
                </div>

                <div class="content-information">
                    <label><mat-icon>location_on</mat-icon>{{ 'profile.address' | translate}}</label>
                    <input type="text" [(ngModel)]="companyData.address"  placeholder="{{ 'profile.address-placeholder' | translate }}" required [disabled]="!editing" [class.editing]="editing">
                </div>

                <div class="content-information select-field">
                    <label>{{ 'profile.country' | translate}}</label>
                    <mat-form-field appearance="outline" *ngIf="editing" class="custom-select">
                        <mat-select placeholder="{{ 'profile.select-country' | translate }}" [(ngModel)]="selectedCountry" [compareWith]="compareCountries" (selectionChange)="onCountryChange()" required>
                            <mat-option *ngFor="let country of countries" [value]="country">{{ country.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <input *ngIf="!editing" type="text" [value]="selectedCountry?.name || ''" placeholder="{{ 'profile.no-country-selected' | translate }}" disabled>
                </div>

                <div class="content-information select-field">
                    <label>	<mat-icon>location_city</mat-icon>{{ 'profile.city' | translate}}</label>
                    <mat-form-field appearance="outline" *ngIf="editing" class="custom-select" [class.disabled]="!selectedCountry">
                        <input matInput placeholder="{{ 'profile.select-city' | translate }}" [(ngModel)]="citySearch" (input)="onCityInput($any($event.target).value)" [matAutocomplete]="auto"  [disabled]="!selectedCountry">
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onCitySelected($event.option.value)" [displayWith]="displayFn" autoActiveFirstOption>
                            <mat-option *ngFor="let city of filteredCities" [value]="city">{{ city.name }}</mat-option>
                            <mat-option *ngIf="filteredCities.length === 0" disabled>{{ 'profile.no-cities-found' | translate }}</mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <input *ngIf="!editing" type="text" [value]="companyData.city?.name || ''" placeholder="{{ 'profile.no-city-selected' | translate }}" disabled>
                </div>

                <div class="content-information">
                    <label><mat-icon>email</mat-icon>{{ 'profile.email' | translate}}</label>
                    <input type="email" [(ngModel)]="companyData.email" placeholder="{{ 'profile.email-placeholder' | translate }}" [disabled]="!editing" [class.editing]="editing" pattern="[^\s@]+@[^\s@]+\.[^\s@]+">
                </div>

                <div class="content-information">
                    <label><mat-icon>phone</mat-icon>{{ 'profile.phone' | translate}}</label>
                    <input type="tel" [(ngModel)]="companyData.phone" placeholder="{{ 'profile.phone-placeholder' | translate }}" [disabled]="!editing" [class.editing]="editing" pattern="[\d\s+]+" (keypress)="onPhoneKeyPress($event)">
                </div>

                <div class="content-information">
                    <label><mat-icon>person</mat-icon>{{ 'profile.inclusion-manager' | translate}}</label>
                    <input type="text" [(ngModel)]="companyData.supervisor" placeholder="{{ 'profile.inclusion-manager-placeholder' | translate }}" required [disabled]="!editing" [class.editing]="editing" pattern="[a-zA-ZÀ-ÿ\s]+" (keypress)="onNameKeyPress($event)">
                </div>

                <div class="content-information select-field">
                    <label>{{ 'profile.sector' | translate}}</label>
                    <mat-form-field appearance="outline" *ngIf="editing" class="custom-select">
                        <mat-select placeholder="{{ 'profile.select-sector' | translate }}" [(ngModel)]="companyData.sector" [compareWith]="compareSectors">
                            <mat-option *ngFor="let sector of sectors" [value]="sector">{{ sector.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <input *ngIf="!editing" type="text" [value]="getSectorName()" placeholder="{{ 'profile.no-sector-selected' | translate }}" disabled>
                </div>

                <div class="content-information badge-field">
                </div>

                <div class="content-information visibility-toggle" *ngIf="companyData">
                    <label>{{ 'profile.profile-visibility' | translate }}</label>
                    
                    <div class="toggle-container">
                        <div class="visibility-display" [class.editable]="editing" (click)="editing && toggleVisibility()">
                            <mat-icon>
                                {{ companyData.published ? 'visibility' : 'visibility_off' }}
                            </mat-icon>
                            <span class="visibility-text">
                                {{ companyData.published ? ('profile.visible' | translate) : ('profile.hidden' | translate) }}
                            </span>
                        </div>
                        <span class="visibility-hint" *ngIf="editing">{{ 'profile.visibility-hint' | translate }}</span>
                    </div>
                </div>

                <div class="password-change">

                <h3>{{ 'profile.change-password' | translate }}</h3>

                    <div class="password-change-inputs">

                        <label for="current-password">{{ 'profile.current-password' | translate }}</label>
                        <input type="password" name="current-password" [(ngModel)]="oldPassword">

                        <label for="new-password">{{ 'profile.new-password' | translate }}</label>
                        <input type="password" name="new-password" [(ngModel)]="newPassword">

                        <label for="confirm-new-password">{{ 'profile.confirm-new-password' | translate }}</label>
                        <input type="password" name="confirm-new-password" [(ngModel)]="confirmNewPassword">

                    </div>

                    <button mat-button color="primary" (click)="changePasswordCompany()">{{ 'profile.change' | translate }}</button>

                </div>

                <div class="password-validation">
                    <app-password-validation [password]="newPassword" (validityChange)="onPasswordValidityChange($event)"></app-password-validation>
                </div>

                <app-password-alert-message></app-password-alert-message>

            </div>
        </div>
    </div>
</div>

